import React, { useState, useMemo, useEffect } from 'react';
import { Grid, makeStyles, TextField } from '@material-ui/core';

import { Field } from 'formik';
import { useSelector } from 'react-redux';
import { SERVICES_PROPERTIES } from 'app/config/services';

import TypeSelector from './TypeSelector/TypeSelector';
import CompanyInfo from './CompanyInfo/CompanyInfo';
import VehiclesSearch from './VehiclesSearch';
import TravelInformation from './TravelInformation';
import VehicleTableAdd from '../../../commonComponents/VehicleTableAdd';
import Itinerary from '../../../commonComponents/Itinerary';
import Passengers from '../../../commonComponents/Passengers';
import Schedules from '../../../commonComponents/Schedules';
import Companies from '../../../commonComponents/Companies';
import AdditionalData from '../../../commonComponents/AdditionalData';

import styles from './styles';
const useStyles = makeStyles(styles);

function Request(props) {
    const classes = useStyles();

    const { values, contextProps, setFieldValue } = props;
    const { canEdit } = contextProps;

    const service = useSelector((state) => state.services.details);

    const configurator = useMemo(() => {
        if (service.cdServico && SERVICES_PROPERTIES[service.cdServico].configurator) {
            return SERVICES_PROPERTIES[service.cdServico].configurator;
        }
        return {};
    }, [service.cdServico]);

    const [passengers, setPassengers] = useState([]);
    const [vehicles, setVehicles] = useState([]);
    const [itinerary, setItinerary] = useState([]);
    const [schedules, setSchedules] = useState([]);
    const [companies, setCompanies] = useState([]);

    useEffect(() => {
        const init = async () => {
            setPassengers(values.passageiros || []);
            setVehicles(values.licencaVeiculos || []);
            setItinerary(values.itinerario || []);
            setSchedules(values.horarios || []);
            setCompanies(values.empresas || []);
        };
        init();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleChangeLists = (list, type) => {
        // eslint-disable-next-line default-case
        switch (type) {
            case 'passengers':
                setPassengers(list);
                setFieldValue('passageiros', list);
                break;
            case 'vehicles':
                setVehicles(list);
                setFieldValue('licencaVeiculos', list);
                break;
            case 'itinerary':
                setItinerary(list);
                setFieldValue('itinerario', list);
                break;
            case 'schedules':
                setSchedules(list);
                setFieldValue('horarios', list);
                break;
            case 'companies':
                setCompanies(list);
                setFieldValue('empresas', list);
                break;
        }
    };

    return (
        <Grid container spacing={3} className={classes.containerMainData}>
            {configurator.hasCompanyInfo && <CompanyInfo {...props} classes={classes} />}

            {configurator.hasTypeSelector && (
                <Grid item xs={12}>
                    <TypeSelector {...props} classes={classes} />
                </Grid>
            )}
            {configurator.hasVehicleSearch && (
                <Grid item xs={12}>
                    <VehiclesSearch {...props} classes={classes} vehicles={vehicles} />
                </Grid>
            )}
            {configurator.hasTravelInformation && (
                <Grid item xs={12}>
                    <TravelInformation {...props} classes={classes} />
                </Grid>
            )}
            {configurator.hasVehicle && (
                <Grid item xs={12}>
                    <VehicleTableAdd
                        {...props}
                        classes={classes}
                        data={vehicles}
                        setData={(list) => handleChangeLists(list, 'vehicles')}
                    />
                </Grid>
            )}
            {configurator.hasItinerary && (
                <Grid item xs={12}>
                    <Itinerary
                        {...props}
                        classes={classes}
                        data={itinerary}
                        setData={(list) => handleChangeLists(list, 'itinerary')}
                    />
                </Grid>
            )}
            {configurator.hasPassengers && (
                <Grid item xs={12}>
                    <Passengers
                        {...props}
                        classes={classes}
                        data={passengers}
                        setData={(list) => handleChangeLists(list, 'passengers')}
                    />
                </Grid>
            )}
            {configurator.hasSchedules && (
                <Grid item xs={12}>
                    <Schedules
                        {...props}
                        classes={classes}
                        data={schedules}
                        setData={(list) => handleChangeLists(list, 'schedules')}
                    />
                </Grid>
            )}
            {configurator.hasCompanies && (
                <Grid item xs={12}>
                    <Companies
                        {...props}
                        classes={classes}
                        data={companies}
                        setData={(list) => handleChangeLists(list, 'companies')}
                    />
                </Grid>
            )}
            {configurator.hasAditionalData && (
                <Grid item xs={12}>
                    <AdditionalData {...props} classes={classes} />
                </Grid>
            )}
            <Grid item xs={12}>
                <Field
                    name="deObservacao"
                    label="Observações"
                    variant="filled"
                    margin="dense"
                    disabled={!canEdit}
                    multiline
                    minRows={4}
                    fullWidth
                    as={TextField}
                    inputProps={{
                        maxLength: 5000,
                    }}
                />
            </Grid>
        </Grid>
    );
}

export default Request;
